var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "card-box",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              { staticClass: "iframe", attrs: { bordered: false } },
              [
                !_vm.splashFrom.adList.length
                  ? _c("div", { staticClass: "nofonts" }, [
                      _vm._v("暂无照片，请添加~"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "swiper",
                  {
                    staticClass: "swiperimg on",
                    attrs: { options: _vm.swiperOption },
                  },
                  _vm._l(_vm.splashFrom.adList, function (item, index) {
                    return _c(
                      "swiper-slide",
                      { key: index + "a", staticClass: "swiperimg on" },
                      [
                        _c("img", {
                          attrs: { src: item.imageUrl, mode: "aspectFill" },
                        }),
                        _vm._v(
                          "\n            " + _vm._s(item) + "\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "ml20" }, [
                _c("div", { staticClass: "right-box" }, [
                  _c("div", { staticClass: "title-bar-line" }, [
                    _vm._v("开屏广告设置"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "建议尺寸：750 * 1334px，拖拽图片可调整图片顺序哦，最多添加五张"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "list-box mt20" },
                    [
                      _c(
                        "el-form",
                        { attrs: { model: _vm.splashFrom } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开屏广告:" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                  width: 55,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                },
                                model: {
                                  value: _vm.splashFrom.splashAdSwitch,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.splashFrom,
                                      "splashAdSwitch",
                                      $$v
                                    )
                                  },
                                  expression: "splashFrom.splashAdSwitch",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "广告时间:" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  type: "number",
                                  size: "small",
                                  min: 1,
                                  placeholder: "请输入开屏广告时间",
                                },
                                model: {
                                  value: _vm.splashFrom.splashAdShowTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.splashFrom,
                                      "splashAdShowTime",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "splashFrom.splashAdShowTime",
                                },
                              }),
                              _vm._v("（单位：秒）\n                  "),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  "广告N秒之后进行自动关闭（按照广告时间进行倒计时展示）。"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "展示间隔:" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  type: "number",
                                  size: "small",
                                  min: 0,
                                  placeholder: "请输入广告间隔时间",
                                },
                                model: {
                                  value: _vm.splashFrom.splashAdShowInterval,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.splashFrom,
                                      "splashAdShowInterval",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "splashFrom.splashAdShowInterval",
                                },
                              }),
                              _vm._v("（单位：小时）\n                  "),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  "\n                    在设置的时间内，重复打开商城，只展示一次开屏广告。设置0代表每次进入商城均会出现开屏广告。\n                  "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("FromList", {
                        attrs: { configObj: _vm.advertisementConfig },
                        on: { getPicList: _vm.getPicList },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("el-card", { staticClass: "bottom-card" }, [
        _c(
          "div",
          { staticClass: "save" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "hasPermi",
                    rawName: "v-hasPermi",
                    value: ["admin:page:layout:splash:ad:save"],
                    expression: "['admin:page:layout:splash:ad:save']",
                  },
                  {
                    name: "debounceClick",
                    rawName: "v-debounceClick",
                    value: _vm.handleAdvertisementSave,
                    expression: "handleAdvertisementSave",
                  },
                ],
                attrs: { size: "small", type: "primary" },
              },
              [_vm._v(_vm._s(_vm.loadingBtn ? "提交中 ..." : "保存"))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }